import { Form, Input } from "antd";
import { requiredField } from "../common/common";
import SimpleFormPage from "../common/SimpleFormPage";

export default function () {
  return (
    <SimpleFormPage title="Nuovo cantiere" path="workSite">
      <Form.Item label="Descrizione" rules={[requiredField]} name="description">
        <Input />
      </Form.Item>
      <Form.Item label="Cliente" rules={[requiredField]} name="customer">
        <Input />
      </Form.Item>
      <Form.Item label="Indirizzo" rules={[requiredField]} name="fullAddress">
        <Input />
      </Form.Item>
    </SimpleFormPage>
  );
}
